// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_51-6";
export var headerCell = "_51-2";
export var rowWrapper = "_51-4";
export var stickyAggregationCell = "_51-a";
export var stickyAggregationRow = "_51-7";
export var stickyColumnCell = "_51-9";
export var stickyColumnHeaderCell = "_51-8";
export var table = "_51-1";
export var virtualRowWrapper = "_51-5";
export var virtualTableContainer = "_51-0";
export var white = "_51-3";